module.exports = __webpack_public_path__ + "static/media/HairRemoval02.bc1c830b.jpeg";